import { atom, useRecoilValue } from 'recoil'
import { NotificationInfoResult } from '../../services/web/types/responseWebServiceTypes'
export type NotificationStoreType = {
    notificationInfo: NotificationInfoResult[] | null
}
export const notificationStore = atom<NotificationStoreType>({
    key: 'notificationStore',
    default: {
        notificationInfo: null,
    },
})

const useNotificationStore = () => {
    const notificationState = useRecoilValue(notificationStore)
    return {
        ...notificationState,
    }
}

export default useNotificationStore
